/**
 * Member-facing submission status timeline.
 * Maps the internal 15-state machine to 5 friendly steps.
 */
const STEPS = [
  { key: "submitted",   label: "Submitted" },
  { key: "review",      label: "Under Review" },
  { key: "validation",  label: "Validation" },
  { key: "approval",    label: "Approval" },
  { key: "published",   label: "Published" },
];

const INFO_STEP = { key: "info_requested", label: "Information Requested" };

const STATUS_TO_STEP = {
  draft:                  "submitted",
  submitted:              "submitted",
  under_review:           "review",
  more_info_requested:    "info_requested",
  validation_requested:   "validation",
  validation_in_progress: "validation",
  validated:              "validation",
  validation_uncertain:   "validation",
  validation_failed:      "approval",
  ready_for_approval:     "approval",
  approved:               "approval",
  denied:                 "approval",
  ready_to_publish:       "approval",
  published:              "published",
  archived:               "submitted",
};

export function MemberTimeline({ status }) {
  const currentKey = STATUS_TO_STEP[status] || "submitted";
  const isInfo = currentKey === "info_requested";
  const displaySteps = isInfo
    ? [STEPS[0], INFO_STEP, STEPS[1], STEPS[2], STEPS[3], STEPS[4]]
    : STEPS;
  const currentIndex = displaySteps.findIndex((s) => s.key === currentKey);

  return (
    <div className="timeline" role="list" data-testid="member-timeline">
      {displaySteps.map((s, i) => {
        const done = i < currentIndex;
        const active = i === currentIndex;
        return (
          <span key={s.key} className="contents">
            <span
              role="listitem"
              className={`timeline-step ${active ? "active" : done ? "done" : ""}`}
              data-testid={`timeline-step-${s.key}`}
              aria-current={active ? "step" : undefined}
            >
              {done && <span aria-hidden="true">✓</span>}
              {s.label}
            </span>
            {i < displaySteps.length - 1 && (
              <span className={`timeline-connector ${done ? "done" : ""}`} aria-hidden="true" />
            )}
          </span>
        );
      })}
    </div>
  );
}
